<template>
    <entity-editor
        entity="ritual"
        :id="id"
        api-name="ritualCircles"
        :new-entity="newRitualCircle"
        read-router-name="readRitualCircle"
        @isDirtyChange="handleIsDirtyChange"
    >
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.name" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="name" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-select
                        v-model="doc.size"
                        :rules="[requiredRule]"
                        :items="circleSize"
                        :disabled="isLoading"
                        label="Circle Size"
                        outlined
                        dense
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Circle Size" />
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-checkbox v-model="doc.active" label="Is Active?" dense class="mt-1"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-checkbox v-model="doc.isHidden" label="Is Hidden?" dense class="mt-1"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.flavour" label="Flavour" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.location" label="Location" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.bounceLocation" label="Bounce Location" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.description" label="Description" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.notes" label="Notes" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import RequiresLabel from '../../components/RequiredLabel'
export default {
    name: 'ResearchRequestEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    components: {
        'label-required': RequiresLabel,
    },
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            circleSize: [
                { value: 0, text: 'Unknown' },
                { value: 1, text: 'Wellspring' },
                { value: 2, text: 'Huge' },
                { value: 3, text: 'Major' },
                { value: 4, text: 'Minor' },
                { value: 5, text: 'Transport' },
                { value: 6, text: 'TransportBeacon' },
            ],
        }
    },
    methods: {
        newRitualCircle() {
            return {
                name: '',
                size: 0,
                active: true,
                location: '',
                bounceLocation: '',
                description: '',
                notes: '',
                isHidden: false,
                flavour: '',
            }
        },
    },
}
</script>
